export const DAYS_UNTIL_READY = 8;


// WEBPACK FOOTER //
// ./src/components/Home/constants.js